/* Annalise Paints — Portrait Commission Portal: shared behaviours */
(function () {
  var initReveal = function () {
    var items = document.querySelectorAll('.pc-reveal:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    items.forEach(function (el) { io.observe(el); });
  };
  var initCountdowns = function () {
    document.querySelectorAll('[data-pc-countdown]').forEach(function (el) {
      var target = new Date(el.getAttribute('data-pc-countdown')).getTime();
      if (isNaN(target)) return;
      var dEl = el.querySelector('[data-pc-days]');
      var hEl = el.querySelector('[data-pc-hours]');
      var mEl = el.querySelector('[data-pc-mins]');
      var tick = function () {
        var diff = target - Date.now();
        if (diff <= 0) {
          el.setAttribute('data-pc-ended', 'true');
          if (dEl) dEl.textContent = '0';
          if (hEl) hEl.textContent = '0';
          if (mEl) mEl.textContent = '0';
          return;
        }
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        if (dEl) dEl.textContent = d;
        if (hEl) hEl.textContent = h;
        if (mEl) mEl.textContent = m;
      };
      tick();
      setInterval(tick, 60000);
    });
  };
  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initCountdowns();
  });
  document.addEventListener('shopify:section:load', initReveal);
})();
